"use client";

import Script from "next/script";

type GoogleAnalyticsProps = {
  analyticsId?: string;
  googleAdsId?: string;
};

export function buildGoogleTagInitScript({
  analyticsId,
  googleAdsId,
}: {
  analyticsId?: string;
  googleAdsId?: string;
}) {
  return `
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag(){window.dataLayer.push(arguments);};
    gtag('js', new Date());
    ${analyticsId ? `gtag('config', '${analyticsId}', { send_page_view: false });` : ""}
    ${googleAdsId ? `gtag('config', '${googleAdsId}', { send_page_view: false });` : ""}
  `;
}

export default function GoogleAnalytics({
  analyticsId: rawAnalyticsId,
  googleAdsId: rawGoogleAdsId,
}: GoogleAnalyticsProps) {
  const analyticsId = rawAnalyticsId?.trim();
  const googleAdsId = rawGoogleAdsId?.trim();

  // Do not track in development
  const tagId = analyticsId || googleAdsId;

  if (process.env.NODE_ENV !== "production" || !tagId) {
    return null;
  }

  return (
    <>
      <Script
        id="google-tag"
        src={`https://www.googletagmanager.com/gtag/js?id=${tagId}`}
        strategy="afterInteractive"
      />
      <Script id="google-tag-init" strategy="afterInteractive">
        {buildGoogleTagInitScript({ analyticsId, googleAdsId })}
      </Script>
    </>
  );
}
